export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.announcements': '公告',
  'menu.policies': '制度',
  'menu.supplies': '物资',
  'menu.supplies.workbench': '工作台',
  'menu.supplies.inventory': '库存中心',
  'menu.supplies.receive': '领用管理',
  'menu.supplies.purchase': '采购管理',
  'menu.supplies.check': '盘点管理',
  'menu.supplies.rule': '规则中心',
  'menu.supplies.statistics': '统计分析',
  'menu.supplies.workflow': '审批中心',
  'menu.meetings': '会议',
  'menu.meetings.calendar': '个人中心',
  'menu.meetings.bookings': '预约列表',
  'menu.meetings.rooms': '会议室列表',
  'menu.meetings.minutes': '会议纪要',
  'menu.meetings.reports': '利用率报告',
  'menu.meetings.dashboard': '工作台',
  'menu.meetings.settings': '设置',
  'menu.meetings.settings.booking': '预定规则配置',
  'menu.meetings.settings.facilities': '会议室设置',
  'menu.meetings.settings.locations': '位置与楼层',
  'menu.meetingRoomDashboard': '工作台',
  'menu.meetingRoomRooms': '会议室列表',
  'menu.meetingRoomBookings': '预约列表',
  'menu.meetingRoomCalendar': '个人中心',
  'menu.meetingRoomMinutes': '会议纪要',
  'menu.meetingRoomUtilizationReport': '利用率报告',
  'menu.meetingRoomSettings': '设置',
  'menu.meetingRoomBookingConfig': '预定规则配置',
  'menu.meetingRoomFacilityTags': '会议室设置',
  'menu.meetingRoomLocationConfig': '位置与楼层',
  'menu.meetingRoomFloorPlan': '楼层图',
  'menu.greenPlants': '绿植',
  'menu.greenplant': '绿植管理',
  'menu.greenplant.dashboard': '绿植工作台',
  'menu.greenplant.assets': '绿植台账',
  'menu.greenplant.spacePoints': '空间点位',
  'menu.greenplant.tasks': '养护与异常',
  'menu.greenplant.issues': '异常处理',
  'menu.greenplant.insights': '运营洞察',
  'menu.greenplant.settings': '配置中心',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.settings': '系统设置',
  'menu.settings.modelSettings': '模型设置',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
